/** @jsx jsx */
import React from 'react';
import { css, styled, jsx } from '@compiled/react';
// eslint-disable-next-line jira/graphql/restrict-graphql-in-unnamed-files
import { graphql, useFragment } from 'react-relay';
import Image from '@atlaskit/image';
import { token } from '@atlaskit/tokens';
import type { icon_projectsDirectoryTemplatesSidebar_CardIcon$key } from '@atlassian/jira-relay/src/__generated__/icon_projectsDirectoryTemplatesSidebar_CardIcon.graphql';

interface Props {
	keyRef: icon_projectsDirectoryTemplatesSidebar_CardIcon$key;
	refreshEnabled?: boolean;
}

export const CardIcon = ({ keyRef, refreshEnabled }: Props) => {
	const { iconUrl, iconDarkUrl } = useFragment<icon_projectsDirectoryTemplatesSidebar_CardIcon$key>(
		// eslint-disable-next-line jira/graphql/restrict-graphql-in-unnamed-files
		graphql`
			fragment icon_projectsDirectoryTemplatesSidebar_CardIcon on JiraProjectListViewTemplateItem {
				iconUrl
				iconDarkUrl
			}
		`,
		keyRef,
	);

	if (!iconUrl || !iconDarkUrl) {
		return null;
	}

	return refreshEnabled ? (
		<Image alt="" css={ImageVariationStyles} src={iconUrl} srcDark={iconDarkUrl} />
	) : (
		<IconImage alt="" src={iconUrl} srcDark={iconDarkUrl} />
	);
};

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const IconImage = styled(Image)({
	width: '40px',
	height: '40px',
	// eslint-disable-next-line @atlaskit/design-system/no-unsafe-design-token-usage
	borderRadius: token('radius.small', '3px'),
});

const ImageVariationStyles = css({
	width: '32px',
	height: '32px',
	borderRadius: token('radius.small'),
});

export default CardIcon;
